import { memo, useMemo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useParamsLink } from '@dfl/react-security';
import { useDeleteStockReductionCause } from 'modules/inventory/settings/stock-reduction-cause/hooks/useDeleteStockReductionCause';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { IStockReductionCause } from '../../interfaces';

type UserStatusProps = {
  rowId: string;
  record: IStockReductionCause;
};

const StockReductionCauseRowActions = ({ rowId, record }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const handleEdit = useParamsLink({ edit: rowId });
  const { mutate, isPending, error } = useDeleteStockReductionCause(rowId, onClose);
  const isSystem = useMemo(() => record?.isSystem || false, [record]);
  return (
    <>
      <Stack direction='row' spacing={1}>
        <EditRowActions onClick={handleEdit} />
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
          disabled={isSystem}
        />
      </Stack>
    </>
  );
};

export default memo(StockReductionCauseRowActions);
